import inspirationsService from '../../services/inspirationsService'

class InspirationController {
  searchInspirations = inspirationsService.searchInspirations
  fetchInspirationById = inspirationsService.fetchInspirationById
  deleteInspirationById = inspirationsService.deleteInspirationById
  fetchAllInspirationTags = inspirationsService.fetchAllInspirationTags
}

export default new InspirationController()



// WEBPACK FOOTER //
// ../src/controllers/inspirationsController/inspirationsController.js